// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-desc-row td {
  padding-top: 0px;
}

tr.visible-hover > td {
  padding-bottom: 2px;
}

.rf-column-td {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
